<template>
    <span>
        <v-icon-button
            type="basic"
            @click="openModal"
            :disabled="!hasTwoCustomers">
        <v-icon icon="merge"/>
        Merge Duplicate Customers
    </v-icon-button>
    <v-modal
        v-if="isModalOpen"
        title="Merge Duplicate Customers"
        size="extra-large"
        @close="closeModal">
        <template #contents>
            <div class="modal-content">
                <div class="grid-content align-items-center">
                    <div class="grid-item">
                        <customer-summary
                            :customer="originalCustomer"
                            type="message-negative"/>
                    </div>
                    <div class="grid-item no-flex">
                        <v-icon icon="arrow-right"/>
                    </div>
                    <div class="grid-item">
                        <customer-summary
                            :customer="targetCustomer"
                            type="message-info"/>
                    </div>
                    <div class="grid-item grid-item-full margin-top-m">
                        <r-button
                            type="link"
                            :disabled="isProcessing"
                            @click="reverseOrder = !reverseOrder">
                            Reverse merge order
                        </r-button>
                    </div>
                </div>
            </div>
            <div class="modal-content modal-content-secondary">
                <p>All records for <strong>{{getIdentifier(originalCustomer)}}</strong> will be merged into <strong>{{getIdentifier(targetCustomer)}}</strong>.</p>
                <p class="margin-top-m">Customer <strong>{{getIdentifier(originalCustomer)}}</strong> will be deleted.</p>
            </div>
        </template>
        <template #actions>
            <r-button
                @click="apply"
                :loading="isProcessing"
                type="primary">Merge
            </r-button>
        </template>
    </v-modal>
    </span>
</template>

<script>
    import {vIconButton, vIcon} from '@/components/form';
    import BaseBulkAction from '@/components/grid/bulk-actions/base-bulk-action';
    import vModal from '@/components/modal/v-modal';
    import CustomerModel from '@/common/models/customer-model';
    import CustomerSummary from '@/modules/customers/components/merge/customer-summary';

    export default {
        name: 'grid-merge-customers',
        extends: BaseBulkAction,
        components: {
            vIconButton, vIcon, vModal, CustomerSummary,
        },
        computed: {
            hasTwoCustomers() {
                return this.selectedRowCount === 2;
            },
            originalCustomer() {
                let fields = {};
                if (this.hasTwoCustomers) {
                    [{fields}] = this.reverseOrder
                        ? [...this.rows].reverse()
                        : this.rows;
                }
                return new CustomerModel(fields);
            },
            targetCustomer() {
                let fields = {};
                if (this.hasTwoCustomers) {
                    [, {fields}] = this.reverseOrder
                        ? [...this.rows].reverse()
                        : this.rows;
                }
                return new CustomerModel(fields);
            },
        },
        data() {
            return {
                isModalOpen: false,
                reverseOrder: false,
            };
        },
        methods: {
            openModal() {
                this.isModalOpen = true;
            },
            closeModal() {
                this.isModalOpen = false;
            },
            getIdentifier(customer) {
                return `${customer.displayName} (${customer.id})`;
            },
            async apply() {
                const {id} = this.originalCustomer;
                const {id: targetId} = this.targetCustomer;
                this.isProcessing = true;
                try {
                    await this.$api(({customers}) => customers.merge({id, targetId}));
                    this.$toast.positive('Successfully merged customers.');
                    this.closeModal();
                    this.grid.startLoading();
                    this.grid.fetchData({resetOffset: true});
                } catch (error) {
                    this.grid.stopLoading();
                    this.$toast.fromError(error, 'Unable to merge the customers at this time.');
                } finally {
                    this.isProcessing = false;
                }
            },
        },
    };
</script>
